module.exports = __webpack_public_path__ + "fonts/Myriad-Pro-Black.47b279ee.otf";